<template>
  <div v-if="!loading" class="flex flex-col">
    <router-link
      v-if="hasPermission('edit_coupons')"
      :to="{ name: 'couponsCreateForm' }"
      class="primary-button mx-0 mt-4"
      >Crear Cupón</router-link
    >

    <div class="flex flex-col sm:flex-row sm:space-x-4 sm:items-end mt-6">
      <custom-search
        class="w-full sm:w-[400px]"
        placeholder="Buscar por código o nombre"
        v-model="searchText"
        @confirm="search"
        @clear="search"
      />

      <div class="flex flex-col mt-2 sm:mt-0">
        <label for="active_filter" class="text-sm">Estado</label>
        <select
          id="active_filter"
          v-model="activeFilter"
          class="rounded border border-content-100 px-2 py-1"
          @change="search"
        >
          <option value="">Todos</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>
    </div>

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white w-full">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Código</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Tipo</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Valor</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Aplica a</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Usos</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Estado</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="coupon in coupons" :key="coupon.id" class="table-row">
            <td class="table-cell font-mono">{{ coupon.code }}</td>
            <td class="table-cell">{{ coupon.name }}</td>
            <td class="table-cell">{{ coupon.discount_type === "percentage" ? "%" : "$" }}</td>
            <td class="table-cell">
              {{ coupon.discount_type === "percentage"
                ? `${coupon.discount_value}%`
                : integerToCurrency(coupon.discount_value) }}
            </td>
            <td class="table-cell">{{ appliesToLabel(coupon.applies_to) }}</td>
            <td class="table-cell">
              {{ coupon.uses_count }}{{ coupon.max_uses ? ` / ${coupon.max_uses}` : "" }}
            </td>
            <td class="table-cell">
              <span
                :class="[
                  'p-1 text-xs rounded text-white w-fit inline-block',
                  coupon.is_active ? 'bg-success-500' : 'bg-content-300',
                ]"
                >{{ coupon.is_active ? "Activo" : "Inactivo" }}</span
              >
            </td>
            <td class="table-cell">
              <router-link
                :to="{ name: 'couponsDetail', params: { id: coupon.id } }"
                class="secondary-button"
                >Detalle</router-link
              >
            </td>
          </tr>
          <tr v-if="!coupons.length">
            <td colspan="8" class="text-center p-4 text-content-300">
              No hay cupones que mostrar.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Coupons",

  components: { Pagination },

  data() {
    return {
      coupons: [],
      loading: false,
      currentPage: 1,
      totalPages: 0,
      searchText: "",
      activeFilter: "",
    };
  },

  created() {
    this.$store.commit("setStoreSelectedTab", "coupons");
    this.loadCoupons();
  },

  methods: {
    integerToCurrency,

    appliesToLabel(value) {
      switch (value) {
        case "products":
          return "Productos";
        case "plans":
          return "Planes";
        default:
          return "Todo";
      }
    },

    async loadCoupons() {
      this.loading = true;

      try {
        const response = await api.coupons.getAllWithQueryParams([
          { name: "page", value: this.currentPage },
          { name: "search", value: this.searchText },
          { name: "is_active", value: this.activeFilter },
        ]);
        this.coupons = response.data || [];
        this.currentPage = response.current_page || 1;
        this.totalPages = response.last_page || 0;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadCoupons();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadCoupons();
    },
  },
};
</script>
